import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppList } from "./App_list"; 
import { AdminFlagProvider } from "./components/providers/AdminFlagProvider";

const list = document.getElementById('list'); 
const root = createRoot(list);

root.render(
  <AdminFlagProvider>
    <AppList />
  </AdminFlagProvider>,
);

window.addEventListener('load', () => {
  const cameraElement = document.getElementById("camera");
  const cameraWrapper = document.getElementById("camera-wrapper");

  if (cameraElement && cameraWrapper) {
    const cameraRotation = cameraElement.getAttribute("rotation");

    if (cameraRotation) {
      const rotation = cameraRotation.split(' ').map(Number);
      const rotationObj = {
        x: -1 * rotation[0],
        y: -1 * rotation[1],
        z: -1 * rotation[2]
      };
      cameraWrapper.setAttribute("rotation", `${rotationObj.x} ${rotationObj.y} ${rotationObj.z}`);
    }
  }
});
